export const collection = Object.freeze({
  sites: "sites",
  users: "users",
  sapLogs: "logs",
  assets: "assets",
  plants: "plants",
  action: "action",
  category: "category",
  finding: "finding",
  sapAssets: "sap_assets",
  inputHelp: "input_help",
  siteTrails: "site_trails",
  assessments: "assessments",
  assetTrails: "asset_trails",
  rolesMaster: "roles_master",
  assetMaster: "asset_master",
  notifications: "notifications",
  sapAssetMaster: "sap_asset_master",
  subAssetMaster: "sub_asset_master",
  syncAssetMaster: "sync_asset_master",
  sapConfiguration: "sap_configuration",
  unregistered_login: "unregistered_login",
  mm_inventory_req_update: "mm_inventory_req_update",
});
